<template><!-- svgo-optimised -->
<svg class="icon icon__arrow icon__arrow--down-filled" viewBox="0 0 10 5" xmlns="http://www.w3.org/2000/svg"><path d="m0 0 5 5 5-5H0Z"/></svg></template>